export default __webpack_public_path__ + "static/media/worldtour1.655c637f.PNG";